// src/app/error.service.ts
import { Injectable, ErrorHandler, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http'
@Injectable({
providedIn: 'root'
})
export class ErrorService implements ErrorHandler{
 
 constructor(private zone: NgZone,private injector: Injector, private _router: Router) { }
 handleError(error: any) {
  const router = this.injector.get(Router);
  if (Error instanceof HttpErrorResponse) {
   console.log(error.status);
  }
  else {
    console.log("Error : ");
    console.log(error);    
   console.error("An error occurred here!");
   this.zone.run(() => {
    this._router.navigate(['/error']);
});
  }
  // router.navigate(['error']);
  }
}